import React, { useState, useCallback } from 'react';

export default function MenuBar({ links }) {

  const [open, setOpen] = useState(false)

  const [height, setHeight] = useState(0);

  const measuredRef = useCallback(node => {
    if (node !== null) {

      setHeight(node.scrollHeight);
    }
  }, []);


  function changeBorder (e,color) {
    e.target.closest('.menu--bar--link').style.borderBottom = `1px solid ${color}`
  }

  function unsetBorder (e){
    e.target.closest('.menu--bar--link').style.borderBottom = `1px solid white`
  }

  return (
    <div className='menu--bar flex justify-center md:flex-col'>
      <button onClick={() => setOpen((state) => !state)} className='text-black menu--bar--link hidden md:block '>
        Menu
      </button>
      <div ref={measuredRef} className={'menu--links w-full  justify-center  hidden md:block'} style={{ height: (open ? `${height}px` : '0px') }}>

        {links.map(({ name, link, color },index) => (
          <div className='menu--bar--link' >
            <a key={index} style={{ color }} href={link}>
              {name}
            </a>
          </div>
        ))}

      </div>
      <div className={'menu--links w-full flex justify-center  md:hidden'}>
        {links.map(({ name, link, color },index) => (
          <button className='menu--bar--link' onMouseEnter={(e) => {changeBorder(e,color)}} onMouseLeave={unsetBorder}>
            <a  key={index} style={{ color }} href={link}>
              {name}
            </a>
          </button>
        ))}
      </div>
    </div>
  );
}
